import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-embedded-report',
  templateUrl: './embedded-report.component.html',
  styleUrls: ['./embedded-report.component.scss'],
  standalone: false,
})
export class EmbeddedReportComponent implements OnInit {
  reportUrl!: SafeResourceUrl;
  reportTitle = '';

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    const url = this.route.snapshot.data['reportUrl'] as string;
    this.reportTitle = this.route.snapshot.data['reportTitle'] as string;
    this.reportUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}